module.exports = flarum.reg.get('core', 'common/states/SearchState');